import { render, staticRenderFns } from "./SoftwareDetailsScreen.vue?vue&type=template&id=3e8948e7&"
import script from "./SoftwareDetailsScreen.vue?vue&type=script&lang=ts&"
export * from "./SoftwareDetailsScreen.vue?vue&type=script&lang=ts&"
import style0 from "./SoftwareDetailsScreen.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports